import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {CreateContactenos} from './Components/CreateContactenos'
import {ViewContactenos} from './Components/ViewContactenos'
import {useIntl} from 'react-intl'

const carsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Menú Contáctenos',
    path: '/menu/administracion/contactenos',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ContactenosPage = () => {
  const intl = useIntl()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='create'
          element={
            <>
              <PageTitle breadcrumbs={carsBreadCrumbs}>
                {intl.formatMessage({id: 'CONTACTUS_MENU'})}
              </PageTitle>
              <CreateContactenos />
            </>
          }
        />

        <Route
          path='view'
          element={
            <>
              <PageTitle breadcrumbs={carsBreadCrumbs}>
                {intl.formatMessage({id: 'CONTACTUS_MENU'})}
              </PageTitle>
              <ViewContactenos />
            </>
          }
        />

        <Route index element={<Navigate to='/menu/administracion/contactenos' />} />
      </Route>
    </Routes>
  )
}

export default ContactenosPage
